/* Herewear collection enhancement. Loaded only on collection pages.
   One job: settle the product cards in as they enter the viewport, once,
   staggered along the row. Nothing here touches facets, sorting,
   pagination, or the cart.

   Safety: the CSS only hides a card once this script has added
   .hw-grid-ready to its grid, and a failsafe reveals everything after a
   short delay, so a blocked or slow observer can never leave the grid
   blank. Skipped entirely under prefers-reduced-motion. */

(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const STAGGER_STEP = 45; // ms between cards in the same reveal batch
  const STAGGER_CAP = 6; // never delay a card more than this many steps

  /** @param {Element} item @param {number} i */
  const reveal = (item, i = 0) => {
    item.style.setProperty('--hw-stagger', `${Math.min(i, STAGGER_CAP) * STAGGER_STEP}ms`);
    item.classList.add('hw-in');
  };

  /** @param {Element} grid */
  function enhance(grid) {
    if (grid.dataset.hwBound) return;
    grid.dataset.hwBound = 'true';
    grid.classList.add('hw-grid-ready');

    const io = new IntersectionObserver(
      (entries, obs) => {
        const shown = entries.filter((e) => e.isIntersecting).map((e) => e.target);
        shown.forEach((el, i) => {
          reveal(el, i);
          obs.unobserve(el);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
    );

    grid.querySelectorAll('.product-grid__item').forEach((el) => io.observe(el));

    // Filtered / paginated re-renders: reveal new cards at once, no stagger,
    // so the grid feels instant while filtering.
    new MutationObserver((records) => {
      for (const rec of records) {
        rec.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;
          const items = node.matches?.('.product-grid__item')
            ? [node]
            : node.querySelectorAll?.('.product-grid__item') ?? [];
          items.forEach((el) => reveal(el));
        });
      }
    }).observe(grid, { childList: true, subtree: true });

    // Failsafe: whatever happened, nothing stays hidden.
    setTimeout(
      () => grid.querySelectorAll('.product-grid__item:not(.hw-in)').forEach((el) => reveal(el)),
      1400
    );
  }

  function init() {
    document.querySelectorAll('.product-grid-container .product-grid').forEach(enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
